import { jsx, jsxs } from "react/jsx-runtime";
import { AlertDialog, Button, XStack, YStack } from "tamagui";
function AlertDialogDemo() {
  return /* @__PURE__ */ jsxs(AlertDialog, { native: true, children: [
    /* @__PURE__ */ jsx(AlertDialog.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { children: "Show Alert" }) }),
    /* @__PURE__ */ jsxs(AlertDialog.Portal, { children: [
      /* @__PURE__ */ jsx(
        AlertDialog.Overlay,
        {
          animation: "quick",
          opacity: 0.5,
          enterStyle: { opacity: 0 },
          exitStyle: { opacity: 0 }
        },
        "overlay"
      ),
      /* @__PURE__ */ jsx(
        AlertDialog.Content,
        {
          bordered: true,
          elevate: true,
          animation: [
            "quick",
            {
              opacity: {
                overshootClamping: true
              }
            }
          ],
          enterStyle: { x: 0, y: -20, opacity: 0, scale: 0.9 },
          exitStyle: { x: 0, y: 10, opacity: 0, scale: 0.95 },
          x: 0,
          scale: 1,
          opacity: 1,
          y: 0,
          children: /* @__PURE__ */ jsxs(YStack, { space: true, children: [
            /* @__PURE__ */ jsx(AlertDialog.Title, { children: "Accept" }),
            /* @__PURE__ */ jsx(AlertDialog.Description, { children: "By pressing yes, you accept our terms and conditions." }),
            /* @__PURE__ */ jsxs(XStack, { space: "$3", justifyContent: "flex-end", children: [
              /* @__PURE__ */ jsx(AlertDialog.Cancel, { asChild: true, children: /* @__PURE__ */ jsx(Button, { children: "Cancel" }) }),
              /* @__PURE__ */ jsx(AlertDialog.Action, { asChild: true, children: /* @__PURE__ */ jsx(Button, { theme: "active", children: "Accept" }) })
            ] })
          ] })
        },
        "content"
      )
    ] })
  ] });
}
export {
  AlertDialogDemo
};
//# sourceMappingURL=AlertDialogDemo.js.map
